import { render, staticRenderFns } from "./switchConfig.vue?vue&type=template&id=79f61413&scoped=true&"
import script from "./switchConfig.vue?vue&type=script&lang=js&"
export * from "./switchConfig.vue?vue&type=script&lang=js&"
import style0 from "./switchConfig.vue?vue&type=style&index=0&id=79f61413&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f61413",
  null
  
)

export default component.exports